import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom';

const Footer = () => {
    const navigate = useNavigate(); // Add this hook

    const translations = {
        english: {
            logo: 'FinLink',
            navHome: 'Home',
            navServices: 'Services',
            navAbout: 'About us',
            navDsa: 'Become Partner',

            navFaq: 'FAQ',
            navContact: 'Contact',
            navCareer: 'Career with us',
            navHelp: 'Help Desk',
            partnerButton: 'Login',
            applyButton: 'Become DSA',

            heroTitleLine1: "India's Leading Loan",
            heroTitleLine2: "Financial Services Platform",
            heroDescription: 'Connect with 100+ banking partners for Home Loans, Personal Loans, Business Loans, Credit Cards, Insurance and more. Get best rates with instant eligibility check and digital document submission.',
            exploreButton: 'Check Eligibility',
            cibilButton: 'Check CIBIL Score',


            statExpText: 'Years Experience',
            statPartnersText: 'Banking Partners',
            statCitiesText: 'Freelancers',
            statLoansText: 'Satiesfied Customer',

            productsTitle: 'We Make a Wide Range of Financial Products Affordable',
            productsSubtitle: 'That suits your client needs! Choose from our comprehensive financial solutions',

            product1Title: 'Home Loan',
            product1Desc: 'Your dream home awaits - Explore our range of home loan products with flexible options.',
            product1Feature1: 'Lowest interest rates starting from 8.5%',
            product1Feature2: 'Up to 90% of property value',
            product1Feature3: 'Long tenure up to 30 years',
            product1Button: 'Check Eligibility',

            product2Title: 'Personal Loan',
            product2Desc: 'Achieve your dreams with our versatile personal loan options for all needs.',
            product2Feature1: 'Up to ₹40 Lakhs amount',
            product2Feature2: 'Instant approval in 24 hours',
            product2Feature3: 'No collateral required',
            product2Button: 'Become DSA',

            product3Title: 'Loan Against Property',
            product3Desc: 'Unlock your property value with ready-made loan solutions at attractive rates.',
            product3Feature1: 'High value loans available',
            product3Feature2: 'Lowest interest rates',
            product3Feature3: 'Flexible repayment options',
            product3Button: 'Get Offers',

            product4Title: 'Business Loan',
            product4Desc: 'Accelerate your business growth with our flexible financing options and quick disbursal.',
            product4Feature1: 'Up to ₹2 Crore',
            product4Feature2: 'Minimal documentation',
            product4Feature3: 'Collateral-free options',
            product4Button: 'Boost Business',

            product5Title: 'Car Loan',
            product5Desc: 'Drive your dream car with our quick and flexible car loans for new and used vehicles.',
            product5Feature1: '100% on-road funding',
            product5Feature2: 'Competitive interest rates',
            product5Feature3: 'Fast processing',
            product5Button: 'Check Offers',

            product6Title: 'Education Loan',
            product6Desc: 'Invest in your child\'s future with our special education loans for domestic studies.',
            product6Feature1: 'Covers tuition + living expenses',
            product6Feature2: 'Moratorium period available',
            product6Feature3: 'Tax benefits under Sec 80E',
            product6Button: 'Apply for Loan',

            insuranceTitle: 'Wide Range of Insurance Products',
            insuranceSubtitle: 'Protect what matters most with our comprehensive insurance solutions',
            insurance1Title: 'Life Insurance',
            insurance1Desc: 'Secure your loved ones future with reliable life insurance plans.',
            insurance1Price: 'Starting at ₹450/month*',
            insurance1Button: 'Get Quote',

            insurance2Title: 'Health Insurance',
            insurance2Desc: 'Ensuring your health is in good hands with best coverage.',
            insurance2Price: 'Starting at ₹450/month*',
            insurance2Button: 'Compare Plans',

            insurance3Title: 'General Insurance',
            insurance3Desc: 'Insurance made easy - Your protection for vehicles and more, our expertise.',
            insurance3Price: 'Starting at ₹450/month*',
            insurance3Button: 'Explore Now',

            processTitle: 'Easy. Convenient. Fast.',
            processSubtitle: 'Simple and quick steps for your loan with 90% success rate',
            step1Title: 'Check Eligibility',
            step1Desc: 'Tell us your need. Our AI matches with best banks based on 90+ criteria.',
            step2Title: 'Compare Offers',
            step2Desc: 'View personalized loan options side by side from 100+ lenders.',
            step3Title: 'Apply Digitally',
            step3Desc: 'Complete application and submit documents directly to selected banks.',
            step4Title: 'Get Disbursal',
            step4Desc: 'Get quick approval and disbursal in hours not weeks.',

            dsaTitle: 'Become DSA Partner',
            dsaSubtitle: 'Join India\'s fastest growing loan distribution network and start earning attractive commissions',
            dsaDescription: 'Loan Agents, Ex-Bankers, Financial Analysts, Insurance Agents, Mutual Fund Agents, Chartered Accountants, Builders or professionals from any field can partner with us.',
            benefit1Title: 'Attractive Commissions',
            benefit1Desc: 'Earn competitive commissions on every successful loan disbursal.',
            benefit2Title: 'Comprehensive Training',
            benefit2Desc: 'Get detailed training on products, processes and sales techniques.',
            benefit3Title: 'Dedicated Support',
            benefit3Desc: '24/7 support team to assist you and your clients throughout the process.',
            dsaButton: 'Register as Partner',

            teamTitle: 'Our Team',
            teamMembers: [
                {
                    name: 'Mr Rakesh Panchal',
                    position: 'FOUNDER',
                    photo: '/avatars/ceo.png'  // Adjust filename if needed, based on your avatars folder
                },
                {
                    name: 'Lauren Pybus',
                    position: 'VP Growth & Development',
                    photo: '/avatars/amit.png'
                },
                {
                    name: 'Raelen Thomas',
                    position: 'VP Finance Operations',
                    photo: '/avatars/amit.png'
                },
                {
                    name: 'Mitchell Fawcett',
                    position: 'VP Strategy',
                    photo: '/avatars/amit.png'
                },
                {
                    name: 'Jieu Segal',
                    position: 'VP Sales & Marketing',
                    photo: '/avatars/amit.png'
                },
                {
                    name: 'Darren Maher',
                    position: 'Creative Director',
                    photo: '/avatars/amit.png'
                },
                {
                    name: 'Ben Van Exan',
                    position: 'Snr Account Executive',
                    photo: '/avatars/amit.png'
                },
                {
                    name: 'John Blown',
                    position: 'Founding Partner',
                    photo: '/avatars/amit.png'
                },
            ],



            faqTitle: 'Frequently Asked Questions',
            faqSubtitle: 'Find answers to common questions about our services and processes',
            faq1Question: 'What is Krishna Finconcept Services and how does it work?',
            faq1Answer: 'Krishna Finconcept Services Is A Comprehensive Financial Services Platform That Connects Customers With 100+ Banking Partners For Loans, Credit Cards And Insurance. We Use AI To Match You With Best Offers, Help With Eligibility Check And Facilitate Digital Document Submission.',
            faq2Question: 'Is my personal and financial information secure?',
            faq2Answer: 'Yes, We Follow Strict Security Protocols And Comply With All Data Protection Regulations. We Never Store Your Bank Login Credentials And Share Information With Lenders Only With Your Explicit Consent For Processing Your Application.',
            faq3Question: 'How can I become a DSA partner?',
            faq3Answer: 'Any Individual Above 25 Years With PAN And Aadhaar Can Become A Partner. Professionals From Finance, Real Estate, Insurance Or Any Field Can Join. We Provide Complete Training, Marketing Support And Timely Commission Payments.',
            faq4Question: 'Do you support all Indian banks?',
            faq4Answer: 'We Partner With 100+ Major Banks And NBFCs Including HDFC, ICICI, SBI, Axis, Kotak, Bajaj Finserv And Many More. While We Don\'t Cover Every Single Bank, We Work With All Major Financial Institutions In India.',





            // New Testimonials
            testimonialTitle: 'What Our Customers Say',
            testimonialSubtitle: 'Hear from our satisfied clients about their experience with Krishna Finconcept Services',
            testimonials: [
                {
                    name: 'Amit Sharma',
                    photo: '/avatars/amit.png',
                    rating: 5,
                    text: 'Krishna Finconcept Services made getting my home loan so easy! Excellent service and quick approval.'
                },
                {
                    name: 'Priya Patel',
                    photo: '/avatars/priya.png',
                    rating: 5,
                    text: 'Great platform with multiple options. Found the best interest rate for my personal loan.'
                },
                {
                    name: 'Rahul Verma',
                    photo: '/avatars/rahul.png',
                    rating: 4,
                    text: 'As a DSA partner, Krishna Finconcept Services has boosted my earnings with timely commissions and great support.'
                },
                {
                    name: 'Sneha Gupta',
                    photo: '/avatars/sneha.png',
                    rating: 5,
                    text: 'Quick and hassle-free health insurance. Saved a lot compared to direct purchase!'
                },
                {
                    name: 'Vikram Singh',
                    photo: '/avatars/amit.png',
                    rating: 5,
                    text: 'User-friendly EMI calculator and seamless business loan application process.'
                }
            ],



            partnersTitle: 'Our Banking Partners',
            partnersSubtitle: 'Trusted by India\'s Leading Financial Institutions',

            footerAbout: 'Krishna Finconcept Services',
            footerDescription: 'India\'s leading financial services platform, connecting customers with 100+ banking partners for loans, credit cards, insurance and investment products.',
            footerProducts: 'Loan Products',
            footerHome: 'Home Loan',
            footerPersonal: 'Personal Loan',
            footerBusiness: 'Business Loan',
            footerLap: 'Loan Against Property',
            footerCar: 'Car Loan',
            footerEducation: 'Education Loan',
            footerServices: 'Other Services',
            footerCredit: 'Credit Cards',
            footerInsurance: 'Insurance',
            footerGold: 'Gold Loan',
            footerBills: 'Bill Payments',
            footerCreditScore: 'Free Credit Score',
            footerPartner: 'Become Partner',
            footerContact: 'Contact Us',
            footerPhone: '9909002220',
            footerEmail: 'krishnafinconcept09@gmail.com',
            footerAddress: 'Available in 4,000+ cities across India',
            footerTiming: 'Mon-Sat: 9AM-9PM | Sun: 10AM-6PM',
            copyrightText: '© 2025 Krishna Finconcept Services Financial Services. All rights reserved.',
            privacyLink: 'Privacy Policy',
            termsLink: 'Terms & Conditions',
            disclaimerLink: 'Disclaimer'
        },
        // FULL hindi translation object (replace the entire hindi: { ... } in your translations)

        // Inside translations = { ... }
        hindi: {
            logo: "फिनलिंक",
            navHome: "होम",
            navServices: "सेवाएं",
            navAbout: 'हमारे बारे में',
            navDsa: "भागीदार बनें",

            navFaq: "सामान्य प्रश्न",
            navContact: "संपर्क करें",
            navCareer: 'करियर हमारे साथ',
            navHelp: 'हेल्प डेस्क',
            partnerButton: "लॉगिन",
            applyButton: "डीएसए बनें",

            heroTitleLine1: "भारत का अग्रणी ऋण",
            heroTitleLine2: "और वित्तीय सेवा प्लेटफॉर्म",
            heroDescription: "100+ बैंकिंग भागीदारों से होम लोन, पर्सनल लोन, बिजनेस लोन, क्रेडिट कार्ड, बीमा और बहुत कुछ के लिए जुड़ें। तत्काल पात्रता जांच और डिजिटल दस्तावेज जमा के साथ सर्वोत्तम दरें प्राप्त करें।",
            exploreButton: "पात्रता जांचें",
            cibilButton: "सीआईबीआईएल स्कोर जांचें",

            statExpText: "वर्षों का अनुभव",
            statPartnersText: "बैंकिंग भागीदार",
            statCitiesText: "फ्रीलांसर्स",
            statLoansText: "संतुष्ट ग्राहक",

            productsTitle: "हम वित्तीय उत्पादों की विस्तृत श्रृंखला को सुलभ बनाते हैं",
            productsSubtitle: "जो आपके ग्राहक की जरूरतों के अनुरूप है! हमारे व्यापक वित्तीय समाधानों में से चुनें",

            product1Title: "होम लोन",
            product1Desc: "आपका सपनों का घर इंतजार कर रहा है - लचीले विकल्पों के साथ हमारे होम लोन उत्पादों की श्रृंखला का अन्वेषण करें।",
            product1Feature1: "8.5% से शुरू होने वाली सबसे कम ब्याज दरें",
            product1Feature2: "संपत्ति मूल्य का 90% तक",
            product1Feature3: "30 वर्ष तक की लंबी अवधि",
            product1Button: "पात्रता जांचें",

            product2Title: "पर्सनल लोन",
            product2Desc: "सभी जरूरतों के लिए हमारे बहुमुखी पर्सनल लोन विकल्पों के साथ अपने सपनों को हासिल करें।",
            product2Feature1: "₹40 लाख तक की राशि",
            product2Feature2: "24 घंटे में तत्काल अनुमोदन",
            product2Feature3: "कोई संपार्श्विक आवश्यक नहीं",
            product2Button: "अभी आवेदन करें",

            product3Title: "प्रॉपर्टी के खिलाफ लोन",
            product3Desc: "आकर्षक दरों पर तैयार किए गए लोन समाधानों के साथ अपनी संपत्ति का मूल्य अनलॉक करें।",
            product3Feature1: "उच्च मूल्य के ऋण उपलब्ध",
            product3Feature2: "सबसे कम ब्याज दरें",
            product3Feature3: "लचीले पुनर्भुगतान विकल्प",
            product3Button: "ऑफ़र प्राप्त करें",

            product4Title: "बिजनेस लोन",
            product4Desc: "हमारे लचीले वित्तपोषण विकल्पों और त्वरित वितरण के साथ अपने व्यवसाय की वृद्धि को तेज करें।",
            product4Feature1: "₹2 करोड़ तक",
            product4Feature2: "न्यूनतम दस्तावेजीकरण",
            product4Feature3: "संपार्श्विक-मुक्त विकल्प",
            product4Button: "व्यवसाय को बढ़ावा दें",

            product5Title: "कार लोन",
            product5Desc: "नई और पुरानी गाड़ियों के लिए हमारे त्वरित और लचीले कार लोन के साथ अपनी सपनों की कार चलाएं।",
            product5Feature1: "100% ऑन-रोड फंडिंग",
            product5Feature2: "प्रतिस्पर्धी ब्याज दरें",
            product5Feature3: "तेज प्रसंस्करण",
            product5Button: "ऑफ़र जांचें",

            product6Title: "एजुकेशन लोन",
            product6Desc: "घरेलू और अंतरराष्ट्रीय अध्ययन के लिए हमारे विशेष शिक्षा ऋण के साथ अपने बच्चे के भविष्य में निवेश करें।",
            product6Feature1: "ट्यूशन + रहने के खर्च को कवर करता है",
            product6Feature2: "मोरेटोरियम अवधि उपलब्ध",
            product6Feature3: "धारा 80ई के तहत कर लाभ",
            product6Button: "ऋण के लिए आवेदन करें",

            insuranceTitle: "बीमा उत्पादों की विस्तृत श्रृंखला",
            insuranceSubtitle: "हमारे व्यापक बीमा समाधानों के साथ सबसे महत्वपूर्ण को सुरक्षित रखें",
            insurance1Title: "जीवन बीमा",
            insurance1Desc: "विश्वसनीय जीवन बीमा योजनाओं के साथ अपने प्रियजनों के भविष्य को सुरक्षित करें।",
            insurance1Price: "₹450/माह* से शुरू",
            insurance1Button: "कोट प्राप्त करें",

            insurance2Title: "स्वास्थ्य बीमा",
            insurance2Desc: "सर्वोत्तम कवरेज के साथ सुनिश्चित करना कि आपका स्वास्थ्य अच्छे हाथों में है।",
            insurance2Price: "₹450/माह* से शुरू",
            insurance2Button: "योजनाओं की तुलना करें",

            insurance3Title: "सामान्य बीमा",
            insurance3Desc: "बीमा को आसान बनाया गया - वाहनों, यात्रा और बहुत कुछ के लिए आपकी सुरक्षा, हमारी विशेषज्ञता।",
            insurance3Price: "₹450/माह* से शुरू",
            insurance3Button: "अब अन्वेषण करें",

            processTitle: "आसान। सुविधाजनक। तेज़।",
            processSubtitle: "90% सफलता दर के साथ आपके ऋण के लिए सरल और त्वरित चरण",
            step1Title: "पात्रता जांचें",
            step1Desc: "हमें अपनी आवश्यकता बताएं। हमारी एआई 90+ मानदंडों के आधार पर सर्वोत्तम बैंकों से मेल खाती है।",
            step2Title: "ऑफ़र की तुलना करें",
            step2Desc: "100+ ऋणदाताओं से व्यक्तिगत ऋण विकल्पों को साइड बाय साइड देखें।",
            step3Title: "डिजिटल रूप से आवेदन करें",
            step3Desc: "आवेदन पूरा करें और दस्तावेज सीधे चयनित बैंकों को जमा करें।",
            step4Title: "भुगतान प्राप्त करें",
            step4Desc: "सप्ताहों के भीतर नहीं, बल्कि घंटों के भीतर त्वरित अनुमोदन और भुगतान प्राप्त करें।",

            dsaTitle: "डीएसए पार्टनर बनें",
            dsaSubtitle: "भारत के सबसे तेजी से बढ़ते ऋण वितरण नेटवर्क में शामिल हों और आकर्षक कमीशन कमाना शुरू करें",
            dsaDescription: "लोन एजेंट, पूर्व बैंकर, वित्तीय विश्लेषक, बीमा एजेंट, म्यूचुअल फंड एजेंट, चार्टर्ड एकाउंटेंट, बिल्डर या किसी अन्य क्षेत्र के पेशेवर हमारे साथ भागीदार बन सकते हैं।",
            benefit1Title: "आकर्षक कमीशन",
            benefit1Desc: "प्रत्येक सफल ऋण भुगतान पर प्रतिस्पर्धी कमीशन कमाएं।",
            benefit2Title: "व्यापक प्रशिक्षण",
            benefit2Desc: "उत्पादों, प्रक्रियाओं और बिक्री तकनीकों पर विस्तृत प्रशिक्षण प्राप्त करें।",
            benefit3Title: "समर्पित समर्थन",
            benefit3Desc: "पूरी प्रक्रिया में आपकी और आपके ग्राहकों की सहायता के लिए 24/7 समर्थन टीम।",
            dsaButton: "पार्टनर के रूप में पंजीकरण करें",

            teamTitle: 'टीम से मिलें',  // Hindi for 'Meet the team'
            teamMembers: [
                {
                    name: 'श्री राकेश पांचाल',
                    position: 'संस्थापक',
                    photo: '/avatars/ceo.png'
                },
                {
                    name: 'Lauren Pybus',
                    position: 'वीपी ग्रोथ एंड डेवलपमेंट',
                    photo: '/avatars/amit.png'
                },
                {
                    name: 'Raelen Thomas',
                    position: 'वीपी फाइनेंस ऑपरेशंस',
                    photo: '/avatars/amit.png'
                },
                {
                    name: 'Mitchell Fawcett',
                    position: 'वीपी स्ट्रैटेजी',
                    photo: '/avatars/amit.png'
                },
                {
                    name: 'Jieu Segal',
                    position: 'वीपी सेल्स एंड मार्केटिंग',
                    photo: '/avatars/amit.png'
                },
                {
                    name: 'Darren Maher',
                    position: 'क्रिएटिव डायरेक्टर',
                    photo: '/avatars/amit.png'
                },
                {
                    name: 'Ben Van Exan',
                    position: 'सीनियर अकाउंट एग्जीक्यूटिव',
                    photo: '/avatars/amit.png'
                },
                {
                    name: 'John Blown',
                    position: 'फाउंडिंग पार्टनर',
                    photo: '/avatars/amit.png'
                },
            ],

            faqTitle: "अक्सर पूछे जाने वाले प्रश्न",
            faqSubtitle: "हमारी सेवाओं और प्रक्रियाओं के बारे में सामान्य प्रश्नों के उत्तर खोजें",
            faq1Question: "कृष्णा फिनकॉन्सेप्ट सर्विसेज क्या है और यह कैसे काम करता है?",
            faq1Answer: "कृष्णा फिनकॉन्सेप्ट सर्विसेज एक व्यापक वित्तीय सेवा प्लेटफॉर्म है जो ग्राहकों को लोन, क्रेडिट कार्ड और बीमा के लिए 100+ बैंकिंग भागीदारों से जोड़ता है। हम आपको सर्वोत्तम ऑफ़र से मिलाने, पात्रता जांच में मदद करने और डिजिटल दस्तावेज़ जमा करने की सुविधा के लिए एआई का उपयोग करते हैं।",
            faq2Question: "क्या मेरी व्यक्तिगत और वित्तीय जानकारी सुरक्षित है?",
            faq2Answer: "हां, हम सख्त सुरक्षा प्रोटोकॉल का पालन करते हैं और सभी डेटा संरक्षण विनियमों का अनुपालन करते हैं। हम आपके बैंक लॉगिन क्रेडेंशियल्स कभी स्टोर नहीं करते हैं और केवल आपके आवेदन के प्रसंस्करण के लिए आपकी स्पष्ट सहमति के साथ ऋणदाताओं के साथ जानकारी साझा करते हैं।",
            faq3Question: "मैं डीएसए पार्टनर कैसे बन सकता हूं?",
            faq3Answer: "पैन कार्ड और आधार कार्ड वाला कोई भी 25+ आयु वर्ग का व्यक्ति भागीदार बन सकता है। वित्त, रियल एस्टेट, बीमा या किसी भी क्षेत्र के पेशेवर शामिल हो सकते हैं। हम पूर्ण प्रशिक्षण, विपणन सहायता और समय पर कमीशन भुगतान प्रदान करते हैं।",
            faq4Question: "क्या आप सभी भारतीय बैंकों का समर्थन करते हैं?",
            faq4Answer: "हम एचडीएफसी, आईसीआईसीआई, एसबीआई, एक्सिस, कोटक, बजाज फिनसर्व और कई अन्य सहित 100+ प्रमुख बैंकों और एनबीएफसी के साथ सहयोग करते हैं। हालांकि हम हर एक बैंक को कवर नहीं करते हैं, लेकिन हम भारत की सभी प्रमुख वित्तीय संस्थाओं के साथ काम करते हैं।",





            testimonialTitle: 'हमारे ग्राहक क्या कहते हैं',
            testimonialSubtitle: 'कृष्णा फिनकॉन्सेप्ट सर्विसेज के साथ अपने अनुभव के बारे में हमारे संतुष्ट ग्राहकों की सुनें',
            testimonials: [
                { name: 'अमित शर्मा', photo: '/avatars/amit.png', rating: 5, text: 'कृष्णा फिनकॉन्सेप्ट सर्विसेज ने मेरे होम लोन को इतना आसान बना दिया! उत्कृष्ट सेवा और तेज़ स्वीकृति।' },
                { name: 'प्रिया पटेल', photo: '/avatars/priya.png', rating: 5, text: 'बहुत सारे विकल्पों वाला शानदार प्लेटफॉर्म। मुझे पर्सनल लोन के लिए सबसे अच्छी ब्याज दर मिली।' },
                { name: 'राहुल वर्मा', photo: '/avatars/rahul.png', rating: 4, text: 'DSA पार्टनर के रूप में, कृष्णा फिनकॉन्सेप्ट सर्विसेज ने समय पर कमीशन और बेहतरीन सपोर्ट से मेरी कमाई बढ़ाई है।' },
                { name: 'स्नेहा गुप्ता', photo: '/avatars/sneha.png', rating: 5, text: 'तेज़ और परेशानी-मुक्त हेल्थ इंश्योरेंस। डायरेक्ट खरीदारी की तुलना में बहुत बचत हुई!' },
                { name: 'विक्रम सिंह', photo: '/avatars/vikram.png', rating: 5, text: 'उपयोगकर्ता-अनुकूल EMI कैलकुलेटर और बिजनेस लोन आवेदन की सहज प्रक्रिया।' }
            ],

            partnersTitle: "हमारे बैंकिंग भागीदार",
            partnersSubtitle: "भारत के अग्रणी वित्तीय संस्थानों द्वारा विश्वसनीय",

            // Contact Us Section
            contactHeading: 'हमसे संपर्क करें',
            contactDesc: 'प्रश्न हैं? ऋण, बीमा या भागीदारी अवसरों पर व्यक्तिगत सहायता के लिए हमसे संपर्क करें।',
            phoneTitle: 'हमें कॉल करें',
            phoneDesc: '9909002220\सोम-शनि: सुबह 9-रात 9 | रवि: सुबह 10-शाम 6',
            emailTitle: 'हमें ईमेल करें',
            emailDesc: 'krishnafinconcept09@gmail.com',
            formHeading: 'हमें संदेश भेजें',
            nameLabel: 'आपका नाम',
            emailLabel: 'आपका ईमेल',
            phoneLabel: 'आपका फोन',
            messageLabel: 'आपका संदेश',
            termsText: 'मैं गोपनीयता नीति और उपयोग की शर्तों से सहमत हूं',
            submitButton: 'जमा करें',

            // Banking Partners Section
            bankHeading: 'हमारे भागीदार बैंक और NBFC',
            bankDesc: 'हम आपको सबसे अच्छे डील्स लाने के लिए 100+ बैंकों और NBFC के साथ भागीदारी करते हैं।',
            viewAll: 'सभी देखें',

            footerAbout: "कृष्णा फिनकॉन्सेप्ट सर्विसेज",
            footerDescription: "भारत का अग्रणी वित्तीय सेवा प्लेटफॉर्म, ग्राहकों को लोन, क्रेडिट कार्ड, बीमा और निवेश उत्पादों के लिए 100+ बैंकिंग भागीदारों से जोड़ता है।",
            footerProducts: "ऋण उत्पाद",
            footerHome: "होम लोन",
            footerPersonal: "पर्सनल लोन",
            footerBusiness: "बिजनेस लोन",
            footerLap: "प्रॉपर्टी के खिलाफ लोन",
            footerCar: "कार लोन",
            footerEducation: "शिक्षा ऋण",
            footerServices: "अन्य सेवाएं",
            footerCredit: "क्रेडिट कार्ड",
            footerInsurance: "बीमा",
            footerGold: "गोल्ड लोन",
            footerBills: "बिल भुगतान",
            footerCreditScore: "मुफ्त क्रेडिट स्कोर",
            footerPartner: "भागीदार बनें",
            footerContact: "हमसे संपर्क करें",
            footerPhone: "9909002220",
            footerEmail: "krishnafinconcept09@gmail.com",
            footerAddress: "भारत के 4,000+ शहरों में उपलब्ध",
            footerTiming: "सोम-शनि: सुबह 9-रात 9 | रवि: सुबह 10-शाम 6",
            copyrightText: "© 2025 कृष्णा फिनकॉन्सेप्ट सर्विसेज फाइनेंशियल सर्विसेज। सभी अधिकार सुरक्षित।",
            privacyLink: "गोपनीयता नीति",
            termsLink: "नियम एवं शर्तें",
            disclaimerLink: "डिस्क्लेमर"
        },
        // FULL gujarati translation object (replace the entire gujarati: { ... } in your translations)

        gujarati: {
            logo: "ફિનલિંક",
            navHome: "હોમ",
            navServices: "સેવાઓ",
            navAbout: 'અમારા વિશે',
            navDsa: "ભાગીદાર બનો",

            navFaq: "પ્રશ્નો-જવાબો",
            navContact: "સંપર્ક કરો",
            navCareer: 'કારકિર્દી અમારી સાથે',
            navHelp: 'હેલ્પ ડેસ્ક',
            partnerButton: "લૉગિન",
            applyButton: "DSA બની જાઓ",

            heroTitleLine1: "ભારતની અગ્રણી લોન",
            heroTitleLine2: "અને નાણાકીય સેવા પ્લેટફોર્મ",
            heroDescription: "100+ બેંકિંગ ભાગીદારો સાથે હોમ લોન, પર્સનલ લોન, બિઝનેસ લોન, ક્રેડિટ કાર્ડ, બીમા અને ઘણું બધું માટે જોડાઓ. તાત્કાલિક પાત્રતા તપાસ અને ડિજિટલ દસ્તાવેજ સબમિશન સાથે શ્રેષ્ઠ દરો મેળવો.",
            exploreButton: "પાત્રતા તપાસો",
            cibilButton: "CIBIL સ્કોર તપાસો",

            statExpText: "વર્ષોનો અનુભવ",
            statPartnersText: "બેંકિંગ ભાગીદારો",
            statCitiesText: "ફ્રીલાન્સર્સ",
            statLoansText: "સંતોષિત ગ્રાહક",

            productsTitle: "અમે નાણાકીય ઉત્પાદનોની વિશાળ શ્રેણી સુવિધાજનક બનાવીએ છીએ",
            productsSubtitle: "જે તમારા ગ્રાહકની જરૂરિયાતોને અનુરૂપ છે! અમારી વ્યાપક નાણાકીય ઉકેલોમાંથી પસંદ કરો",

            product1Title: "હોમ લોન",
            product1Desc: "તમારું સ્વપ્નનું ઘર રાહ જોઈ રહ્યું છે - લવચીક વિકલ્પો સાથે અમારી હોમ લોન ઉત્પાદનોની શ્રેણીનું અન્વેષણ કરો.",
            product1Feature1: "8.5% થી શરૂ થતા સૌથી નીચા વ્યાજ દરો",
            product1Feature2: "મિલ્કત મૂલ્યનો 90% સુધી",
            product1Feature3: "30 વર્ષ સુધીની લાંબી મુદત",
            product1Button: "પાત્રતા તપાસો",

            product2Title: "પર્સનલ લોન",
            product2Desc: "બધી જરૂરિયાતો માટે અમારા બહુમુખી પર્સનલ લોન વિકલ્પો સાથે તમારા સપનાને હાંસલ કરો.",
            product2Feature1: "₹40 લાખ સુધીની રકમ",
            product2Feature2: "24 કલાકમાં તાત્કાલિક મંજૂરી",
            product2Feature3: "કોઈ જામીનગીરી જરૂરી નથી",
            product2Button: "હમણાં અરજી કરો",

            product3Title: "મિલકત સામે લોન",
            product3Desc: "આકર્ષક દરે તૈયાર થયેલા લોન ઉકેલો સાથે તમારી મિલકતની કિંમત અનલૉક કરો.",
            product3Feature1: "ઉચ્ચ મૂલ્યના લોન ઉપલબ્ધ",
            product3Feature2: "સૌથી નીચા વ્યાજ દરો",
            product3Feature3: "લવચીક માફક પરત ચૂકવણી વિકલ્પો",
            product3Button: "ઑફર મેળવો",

            product4Title: "બિઝનેસ લોન",
            product4Desc: "અમારા લવચીક નાણાંકીય વિકલ્પો અને ઝડપી ચૂકવણી સાથે તમારા વ્યવસાયની વૃદ્ધિને વેગ આપો.",
            product4Feature1: "₹2 કરોડ સુધી",
            product4Feature2: "ન્યૂનતમ દસ્તાવેજીકરણ",
            product4Feature3: "જામીનગીરી મુક્ત વિકલ્પો",
            product4Button: "વ્યવસાયને વેગ આપો",

            product5Title: "કાર લોન",
            product5Desc: "નવી અને જૂની વાહનો માટે અમારા ઝડપી અને લવચીક કાર લોન સાથે તમારી સ્વપ્નની કાર ચલાવો.",
            product5Feature1: "100% ઓન-રોડ ફંડિંગ",
            product5Feature2: "પ્રતિસ્પર્ધી વ્યાજ દરો",
            product5Feature3: "ઝડપી પ્રોસેસિંગ",
            product5Button: "ઑફર તપાસો",

            product6Title: "એજ્યુકેશન લોન",
            product6Desc: "ઘરેલું અને આંતરરાષ્ટ્રીય અભ્યાસ માટે અમારી વિશિષ્ટ શિક્ષણ લોન સાથે તમારા બાળકના ભવિષ્યમાં રોકાણ કરો.",
            product6Feature1: "ટ્યૂશન + રહેવાનો ખર્ચ આવરી લે છે",
            product6Feature2: "મોરેટોરિયમ અવધિ ઉપલબ્ધ",
            product6Feature3: "કલમ 80ઈ હેઠળ કર લાભ",
            product6Button: "લોન માટે અરજી કરો",

            insuranceTitle: "બીમા ઉત્પાદનોની વિશાળ શ્રેણી",
            insuranceSubtitle: "અમારા વ્યાપક બીમા ઉકેલો સાથે જે સૌથી વધુ મહત્વનું છે તેને સુરક્ષિત કરો",
            insurance1Title: "જીવન બીમા",
            insurance1Desc: "વિશ્વસનીય જીવન બીમા યોજનાઓ સાથે તમારા પ્રિયજનોના ભવિષ્યને સુરક્ષિત કરો.",
            insurance1Price: "₹450/મહિના* થી શરૂ",
            insurance1Button: "કોટ મેળવો",

            insurance2Title: "સ્વાસ્થ્ય બીમા",
            insurance2Desc: "શ્રેષ્ઠ કવરેજ સાથે તમારા સ્વાસ્થ્ય સારા હાથમાં છે તેની ખાતરી કરવી.",
            insurance2Price: "₹450/મહિના* થી શરૂ",
            insurance2Button: "યોજનાઓની તુલના કરો",

            insurance3Title: "સામાન્ય બીમા",
            insurance3Desc: "બીમા સરળ બનાવ્યું - વાહનો, મુસાફરી અને ઘણું બધું માટે તમારું સુરક્ષા, અમારી નિષ્ણાતતા.",
            insurance3Price: "₹450/મહિના* થી શરૂ",
            insurance3Button: "હવે અન્વેષણ કરો",

            processTitle: "સરળ. સુવિધાજનક. ઝડપી.",
            processSubtitle: "90% સફળતા દર સાથે તમારા લોન માટે સરળ અને ઝડપી પગલાં",
            step1Title: "પાત્રતા તપાસો",
            step1Desc: "અમને તમારી જરૂરિયાત જણાવો. અમારી એઆઈ 90+ માપદંડોના આધારે શ્રેષ્ઠ બેંકો સાથે મેળ ખાય છે.",
            step2Title: "ઑફરની તુલના કરો",
            step2Desc: "100+ લોનદાતાઓમાંથી વ્યક્તિગત લોન વિકલ્પોને સાઇડ બાય સાઇડ જુઓ.",
            step3Title: "ડિજિટલ રીતે અરજી કરો",
            step3Desc: "એપ્લિકેશન પૂર્ણ કરો અને દસ્તાવેજો સીધા પસંદ કરેલી બેંકોને સબમિટ કરો.",
            step4Title: "ચુકવણી મેળવો",
            step4Desc: "અઠવાડિયામાં નહીં પરંતુ કલાકોની અંદર ઝડપી મંજૂરી અને ચુકવણી મેળવો.",

            dsaTitle: "ડીએસએ ભાગીદાર બનો",
            dsaSubtitle: "ભારતના સૌથી ઝડપી વધતા લોન વિતરણ નેટવર્કમાં જોડાઓ અને આકર્ષક કમિશન કમાવાનું શરૂ કરો",
            dsaDescription: "લોન એજન્ટ, ભૂતપૂર્વ બેંકર, નાણાકીય વિશ્લેષકો, બીમા એજન્ટ, મ્યુચ્યુઅલ ફંડ એજન્ટ, ચાર્ટર્ડ એકાઉન્ટન્ટ, બિલ્ડર અથવા અન્ય કોઈપણ ક્ષેત્રના વ્યવસાયિકો કોઈપણ અમારા સાથે ભાગીદાર બની શકે છે.",
            benefit1Title: "આકર્ષક કમિશન",
            benefit1Desc: "દરેક સફળ લોન ચુકવણી પર સ્પર્ધાત્મક કમિશન કમાઓ.",
            benefit2Title: "વ્યાપક તાલીમ",
            benefit2Desc: "ઉત્પાદનો, પ્રક્રિયાઓ અને વેચાણ તકનીકો પર વિગતવાર તાલીમ મેળવો.",
            benefit3Title: "સમર્પિત આધાર",
            benefit3Desc: "સમગ્ર પ્રક્રિયામાં તમારી અને તમારા ગ્રાહકોની સહાય માટે 24/7 સપોર્ટ ટીમ.",
            dsaButton: "ભાગીદાર તરીકે નોંધણી કરો",

            teamTitle: 'ટીમને મળો',

            teamMembers: [
                {
                    name: 'શ્રી રાકેશ પંચાલ',
                    position: 'સ્થાપક',
                    photo: '/avatars/ceo.png'
                },
                {
                    name: 'Lauren Pybus',
                    position: 'વીપી ગ્રોથ એન્ડ ડેવલપમેન્ટ',
                    photo: '/avatars/amit.png'
                },
                {
                    name: 'Raelen Thomas',
                    position: 'વીપી ફાઇનાન્સ ઓપરેશન્સ',
                    photo: '/avatars/amit.png'
                },
                {
                    name: 'Mitchell Fawcett',
                    position: 'વીપી સ્ટ્રેટેજી',
                    photo: '/avatars/amit.png'
                },
                {
                    name: 'Jieu Segal',
                    position: 'વીપી સેલ્સ એન્ડ માર્કેટિંગ',
                    photo: '/avatars/amit.png'
                },
                {
                    name: 'Darren Maher',
                    position: 'ક્રિએટિવ ડિરેક્ટર',
                    photo: '/avatars/amit.png'
                },
                {
                    name: 'Ben Van Exan',
                    position: 'સિનિયર એકાઉન્ટ એક્ઝિક્યુટિવ',
                    photo: '/avatars/amit.png'
                },
                {
                    name: 'John Blown',
                    position: 'ફાઉન્ડિંગ પાર્ટનર',
                    photo: '/avatars/amit.png'
                },
            ],

            faqTitle: "વારંવાર પૂછાતા પ્રશ્નો",
            faqSubtitle: "અમારી સેવાઓ અને પ્રક્રિયાઓ વિશેના સામાન્ય પ્રશ્નોના જવાબો શોધો",
            faq1Question: "કૃષ્ણા ફિનકોન્સેપ્ટ સર્વિસેસ શું છે અને તે કેવી રીતે કાર્ય કરે છે?",
            faq1Answer: "કૃષ્ણા ફિનકોન્સેપ્ટ સર્વિસેસ એક વ્યાપક નાણાકીય સેવા પ્લેટફોર્મ છે જે ગ્રાહકોને લોન, ક્રેડિટ કાર્ડ અને બીમા માટે 100+ બેંકિંગ ભાગીદારો સાથે જોડે છે. અમે તમને શ્રેષ્ઠ ઑફર સાથે મેચ કરવા, પાત્રતા તપાસમાં મદદ કરવા અને ડિજિટલ દસ્તાવેજ સબમિશનની સુવિધા માટે એઆઈનો ઉપયોગ કરીએ છીએ.",
            faq2Question: "શું મારી વ્યક્તિગત અને નાણાકીય માહિતી સુરક્ષિત છે?",
            faq2Answer: "હા, અમે કડક સુરક્ષા પ્રોટોકોલનું પાલન કરીએ છીએ અને તમામ ડેટા સંરક્ષણ નિયમોનું પાલન કરીએ છીએ. અમે તમારા બેંક લોગિન ક્રેડેન્શિયલ્સ ક્યારેય સંગ્રહિત કરતા નથી અને ફક્ત તમારી એપ્લિકેશન પ્રોસેસિંગ માટે તમારી સ્પષ્ટ સંમતિ સાથે લોનદાતાઓ સાથે માહિતી શેર કરીએ છીએ.",
            faq3Question: "હું ડીએસએ ભાગીદાર કેવી રીતે બની શકું?",
            faq3Answer: "પૅન કાર્ડ અને આધાર કાર્ડ ધરાવતા 25+ વર્ષની ઉંમરના કોઈપણ વ્યક્તિ ભાગીદાર બની શકે છે. નાણાં, રીઅલ એસ્ટેટ, બીમા અથવા કોઈપણ ક્ષેત્રના વ્યવસાયિકો જોડાઈ શકે છે. અમે સંપૂર્ણ તાલીમ, માર્કેટિંગ સહાય અને સમયસર કમિશન ચુકવણી પ્રદાન કરીએ છીએ.",
            faq4Question: "શું તમે બધા ભારતીય બેંકોને સપોર્ટ કરો છો?",
            faq4Answer: "અમે એચડીએફસી, આઈસીઆઈસીઆઈ, એસબીઆઈ, એક્સિસ, કોટક, બજાજ ફિનસર્વ અને ઘણા બધા સહિત 100+ પ્રમુખ બેંકો અને એનબીએફસી સાથે સહયોગ કરીએ છીએ. જ્યારે અમે દરેક એક બેંકને કવર કરતા નથી, પરંતુ અમે ભારતની તમામ પ્રમુખ નાણાકીય સંસ્થાઓ સાથે કામ કરીએ છીએ.",

            testimonialTitle: 'અમારા ગ્રાહકો શું કહે છે',
            testimonialSubtitle: 'કૃષ્ણા ફિનકોન્સેપ્ટ સર્વિસેસ સાથેના તેમના અનુભવ વિશે અમારા સંતુષ્ટ ગ્રાહકો પાસેથી સાંભળો',
            testimonials: [
                { name: 'અમિત શર્મા', photo: '/avatars/amit.png', rating: 5, text: 'કૃષ્ણા ફિનકોન્સેપ્ટ સર્વિસેસ એ મારી હોમ લોનને ખૂબ સરળ બનાવી! ઉત્તમ સેવા અને ઝડપી મંજૂરી.' },
                { name: 'પ્રિયા પટેલ', photo: '/avatars/priya.png', rating: 5, text: 'ઘણા વિકલ્પો સાથેનું શાનદાર પ્લેટફોર્મ. મને પર્સનલ લોન માટે શ્રેષ્ઠ વ્યાજ દર મળ્યો.' },
                { name: 'રાહુલ વર્મા', photo: '/avatars/rahul.png', rating: 4, text: 'DSA પાર્ટનર તરીકે, કૃષ્ણા ફિનકોન્સેપ્ટ સર્વિસેસ એ સમયસર કમિશન અને શાનદાર સપોર્ટથી મારી કમાણી વધારી છે.' },
                { name: 'સ્નેહા ગુપ્તા', photo: '/avatars/sneha.png', rating: 5, text: 'ઝડપી અને મુશ્કેલી-મુક્ત હેલ્થ ઇન્શ્યોરન્સ. ડાયરેક્ટ ખરીદીની તુલનાએ ઘણી બચત થઈ!' },
                { name: 'વિક્રમ સિંહ', photo: '/avatars/vikram.png', rating: 5, text: 'યુઝર-ફ્રેન્ડલી EMI કેલ્ક્યુલેટર અને બિઝનેસ લોન અરજીની સરળ પ્રક્રિયા.' }
            ],

            partnersTitle: "અમારા બેંકિંગ ભાગીદારો",
            partnersSubtitle: "ભારતની અગ્રણી નાણાકીય સંસ્થાઓ દ્વારા વિશ્વસનીય",

            // Contact Us Section
            contactHeading: 'અમારો સંપર્ક કરો',
            contactDesc: 'પ્રશ્નો છે? લોન, વીમા અથવા ભાગીદારી તકો પર વ્યક્તિગત સહાય માટે અમારો સંપર્ક કરો.',
            phoneTitle: 'અમને કૉલ કરો',
            phoneDesc: '9909002220\nસોમ-શનિ: સવાર 9-રાત 9 | રવિ: સવાર 10-સાંજ 6',
            emailTitle: 'અમને ઈમેઇલ કરો',
            emailDesc: 'krishnafinconcept09@gmail.com',
            formHeading: 'અમને સંદેશ મોકલો',
            nameLabel: 'તમારું નામ',
            emailLabel: 'તમારું ઈમેઇલ',
            phoneLabel: 'તમારો ફોન',
            messageLabel: 'તમારો સંદેશ',
            termsText: 'હું ગોપનીયતા નીતિ અને વપરાશની શરતો સાથે સંમત છું',
            submitButton: 'સબમિટ કરો',

            // Banking Partners Section
            bankHeading: 'અમારા ભાગીદાર બેંક અને NBFC',
            bankDesc: 'અમે તમને શ્રેષ્ઠ ડીલ્સ લાવવા માટે 100+ બેંકો અને NBFC સાથે ભાગીદારી કરીએ છીએ.',
            viewAll: 'બધા જુઓ',

            footerAbout: "કૃષ્ણા ફિનકોન્સેપ્ટ સર્વિસેસ",
            footerDescription: "ભારતનું અગ્રણી નાણાકીય સેવા પ્લેટફોર્મ, ગ્રાહકોને લોન, ક્રેડિટ કાર્ડ, બીમા અને રોકાણ ઉત્પાદનો માટે 100+ બેંકિંગ ભાગીદારો સાથે જોડે છે.",
            footerProducts: "લોન ઉત્પાદનો",
            footerHome: "હોમ લોન",
            footerPersonal: "પર્સનલ લોન",
            footerBusiness: "બિઝનેસ લોન",
            footerLap: "મિલકત સામે લોન",
            footerCar: "કાર લોન",
            footerEducation: "એજ્યુકેશન લોન",
            footerServices: "અન્ય સેવાઓ",
            footerCredit: "ક્રેડિટ કાર્ડ",
            footerInsurance: "બીમા",
            footerGold: "ગોલ્ડ લોન",
            footerBills: "બિલ પેમેન્ટ",
            footerCreditScore: "મફત ક્રેડિટ સ્કોર",
            footerPartner: "ભાગીદાર બનો",
            footerContact: "અમારો સંપર્ક કરો",
            footerPhone: "9909002220",
            footerEmail: "krishnafinconcept09@gmail.com",
            footerAddress: "ભારતના 4,000+ શહેરોમાં ઉપલબ્ધ",
            footerTiming: "સોમ-શનિ: સવાર 9-રાત 9 | રવિ: સવાર 10-સાંજ 6",
            copyrightText: "© 2025 કૃષ્ણા ફિનકોન્સેપ્ટ સર્વિસેસ નાણાકીય સેવાઓ. બધા હક્કો આરક્ષિત.",
            privacyLink: "ગોપનીયતા નીતિ",
            termsLink: "નિયમો અને શરતો",
            disclaimerLink: "નિરાકરણ"
        }
    };
    const [currentLanguage, setCurrentLanguage] = useState('english');
    const t = translations[currentLanguage];
    return (
        < footer >
            <div className="footer-content">
                <div className="footer-section">
                    <h4>{t.footerAbout}</h4>
                    <p>{t.footerDescription}</p>
                    <div className="social-icons">
                        <button className="social-icon">f</button>
                        <button className="social-icon">t</button>
                        <button className="social-icon">in</button>
                        <button className="social-icon">ig</button>
                    </div>
                </div>
                <div className="footer-section">
                    <h4>{t.footerProducts}</h4>
                    <ul className="footer-links">
                        <li><button className="footer-link" onClick={() => navigate('/home-loan')}>{t.footerHome}</button></li>
                        <li><button className="footer-link" onClick={() => navigate('/personal-loan')}>{t.footerPersonal}</button></li>
                        <li><button className="footer-link" onClick={() => navigate('/business-loan')}>{t.footerBusiness}</button></li>
                        <li><button className="footer-link" onClick={() => navigate('/loan-against-property')}>{t.footerLap}</button></li>
                        <li><button className="footer-link" onClick={() => navigate('/car-loan')}>{t.footerCar}</button></li>
                        <li><button className="footer-link" onClick={() => navigate('/education-loan')}>{t.footerEducation}</button></li>
                    </ul>
                </div>
                <div className="footer-section">
                    <h4>{t.footerServices}</h4>
                    <ul className="footer-links">
                        <li><button className="footer-link">{t.footerCredit}</button></li>
                        <li><button className="footer-link">{t.footerInsurance}</button></li>
                        <li><button className="footer-link">{t.footerGold}</button></li>
                        <li><button className="footer-link">{t.footerBills}</button></li>
                        <li><button className="footer-link">{t.footerCreditScore}</button></li>
                    </ul>
                </div>
                <div className="footer-section">
                    <h4>Company</h4>
                    <ul className="footer-links">
                        <li><button className="footer-link"
                        // onClick={() =>
                        //     // setIsDSAFormOpen(true) 
                        // }    
                        >{t.footerPartner}</button></li>
                        <li><button className="footer-link" onClick={() => {
                            // Scroll to contact section
                            document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
                        }}>{t.footerContact}</button></li>
                    </ul>
                </div>
            </div>
            <div className="copyright">
                © {new Date().getFullYear()} Krishna Finconcept Services. All rights reserved.
            </div>
        </footer >
    )
}

export default Footer